const config = {
  '0d365371960e4e8ba9b66200a9b24d1f': {
    dev: 'https://huachengceshi.gz-cmc.com',
    test: 'https://huachengceshi.gz-cmc.com',
    prod: 'https://huachengceshi.gz-cmc.com',
  },
  '5e88c884e2ed4e7a9a8d5225c299f707': {
    dev: 'https://huacheng.gz-cmc.com',
    test: 'https://xinhuacheng.gzcmc.net',
    prod: 'https://huacheng.gz-cmc.com',
  },
  '413a326c3132437dafbe6e5db7ca9efa': {
    dev: 'https://xinxishibao.gz-cmc.com',
    test: 'https://xinxishibao.gz-cmc.com',
    prod: 'https://xinxishibao.gz-cmc.com',
  },
  '59f66474343848b797450adff56d10a0': {
    dev: 'https://qingnianrongmei.gz-cmc.com',
    test: 'https://qingnianrongmei.gz-cmc.com',
    prod: 'https://qingnianrongmei.gz-cmc.com',
  },
  '67f734faaf3942ee8459f1cc6d2afdb0': {
    dev: 'https://suiyueditu.gz-cmc.com',
    test: 'https://suiyueditu.gz-cmc.com',
    prod: 'https://suiyueditu.gz-cmc.com',
  },
  '75370bed288744ecad84f82ff1efd427': {
    dev: 'htps:/nanshaqurongmeitizhongxin.gz-cmc.com',
    test: 'htps:/nanshaqurongmeitizhongxin.gz-cmc.com',
    prod: 'htps:/nanshaqurongmeitizhongxin.gz-cmc.com',
  },
  '78fa6d06b0dd4f27abf341e5efde035a': {
    dev: 'https://yuezengcheng.gz-cmc.com',
    test: 'https://yuezengcheng.gz-cmc.com',
    prod: 'https://yuezengcheng.gz-cmc.com',
  },
  '7eaa0b8cec3e4dcb94917b21a6be3d6b': {
    dev: 'https://nansha.gz-cmc.com',
    test: 'https://nansha.gz-cmc.com',
    prod: 'https://nansha.gz-cmc.com',
  },
  '813ae4b0605945dfbcdd87e88110c7a9': {
    dev: 'https://pdmi.gz-cmc.com',
    test: 'https://pdmi.gz-cmc.com',
    prod: 'https://pdmi.gz-cmc.com',
  },
  c315422f1b894fcca7b0b9f799d78e67: {
    dev: 'https://liwanfabu.gz-cmc.com',
    test: 'https://liwanfabu.gz-cmc.com',
    prod: 'https://liwanfabu.gz-cmc.com',
  },
  c4bb1687e60f41d9876bb764e6e7b149: {
    dev: 'https://shaxituzhi.gz-cmc.com',
    test: 'https://shaxituzhi.gz-cmc.com',
    prod: 'https://shaxituzhi.gz-cmc.com',
  },
  cd4f63bdfdfd41749c7e304bc0d7a6df: {
    dev: 'https://daohuangpugu.gz-cmc.com',
    test: 'https://daohuangpugu.gz-cmc.com',
    prod: 'https://daohuangpugu.gz-cmc.com',
  },

  d755df8bb9fb49ee96052f7dee58d21b: {
    dev: 'https://zhangshangfanyu.gz-cmc.com',
    test: 'https://zhangshangfanyu.gz-cmc.com',
    prod: 'https://zhangshangfanyu.gz-cmc.com',
  },
  d9411616614f481197fdad925d012a66: {
    dev: 'https://shunderongmeitizhongxin.gz-cmc.com',
    test: 'https://shunderongmeitizhongxin.gz-cmc.com',
    prod: 'https://shunderongmeitizhongxin.gz-cmc.com',
  },
  e7c923a26e4743bf87890c19f95a83e6: {
    dev: 'https://guangzhoubaiyun.gz-cmc.com',
    test: 'https://guangzhoubaiyun.gz-cmc.com',
    prod: 'https://guangzhoubaiyun.gz-cmc.com',
  },
  ef60d32eb8134d08b01d58acc0071878: {
    dev: 'https://guangbaoceshirongmei.gz-cmc.com',
    test: 'https://guangbaoceshirongmei.gz-cmc.com',
    prod: 'https://guangbaoceshirongmei.gz-cmc.com',
  },
  f5d14ddece77479183575e4af09e0cc0: {
    dev: 'https://haizhu.gz-cmc.com',
    test: 'https://haizhu.gz-cmc.com',
    prod: 'https://haizhu.gz-cmc.com',
  },
  f9f347c51889405ca578b8f8a0558gfe: {
    dev: 'https://shunderongmei.gz-cmc.com',
    test: 'https://shunderongmei.gz-cmc.com',
    prod: 'https://shunderongmei.gz-cmc.com',
  },
};

export default config as {
  [key: string]: { dev: string; test: string; prod: string };
};
